import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store/index'
import './registerServiceWorker'
import firebase from 'firebase'
import 'firebase/firestore'
import IcFirebaseUploader from 'ic-firebase-uploader'
import 'ic-firebase-uploader/dist/ic-firebase-uploader.min.css'
import VueChartkick from 'vue-chartkick'
import Highcharts from 'highcharts'

import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel)
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime)
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
import "vue-multiselect/dist/vue-multiselect.min.css"

import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, 
  {
    hideModules: {     
      code: true,
      image: true,
      justifyLeft: true,
      justifyCenter: true,
      justifyRight: true,
      removeFormat: true,
    },
    forcePlainTextOnPaste: true
  }
  ); // config is optional. more below
import "vue-wysiwyg/dist/vueWysiwyg.css";

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-125463163-1',
  router
})

console.log('process.env' , process.env)
//console.log('config from .env=' , config)

Vue.prototype.$isMessagingEnabled = false
var config
if(process.env.NODE_ENV==='development' || process.env.NODE_ENV==='staging'){
  /*
  config = {
    apiKey: "AIzaSyCaY0N06B9PiBcr0ZK-ZfhAtNltZTgB11g",
    authDomain: "zzques-2e9f8.firebaseapp.com",
    databaseURL: "https://zzques-2e9f8.firebaseio.com",
    projectId: "zzques-2e9f8",
    storageBucket: "zzques-2e9f8.appspot.com",
    messagingSenderId: "951007987182"
  }
*/
  config = {
    apiKey: "AIzaSyA6vnBvxkCRPHoGGtnf42N9Qh1R0bpzhJQ",
    authDomain: "zzques-staging.firebaseapp.com",
    databaseURL: "https://zzques-staging.firebaseio.com",
    projectId: "zzques-staging",
    storageBucket: "zzques-staging.appspot.com",
    messagingSenderId: "899290077649"    
  } 

  firebase.initializeApp(config);
  try{
    
    Vue.prototype.$messaging = firebase.messaging() 
    Vue.prototype.$messaging.usePublicVapidKey('BLDkhyFDx5PbUPXey6-hBxz1pRELfA_o5MJgteaeRzmpzkFZxCkaEplzeCO7FPvm08LctaZ-1kJhIdegMzKF5KA'); 
    Vue.prototype.$isMessagingEnabled = true
}catch(err){
  console.warn('error with firebase messaging ' + JSON.stringify(err))
}

}else if(process.env.NODE_ENV==='production'){
  config = {
    apiKey: "AIzaSyCaY0N06B9PiBcr0ZK-ZfhAtNltZTgB11g",
    authDomain: "zzques-2e9f8.firebaseapp.com",
    databaseURL: "https://zzques-2e9f8.firebaseio.com",
    projectId: "zzques-2e9f8",
    storageBucket: "zzques-2e9f8.appspot.com",
    messagingSenderId: "951007987182"
  }

  firebase.initializeApp(config);
  try{
    Vue.prototype.$messaging = firebase.messaging() 
    Vue.prototype.$messaging.usePublicVapidKey('BKbh-LA3DgOFAcO_SpBClY7BC2ujpioxS_-uinHmdpRj8sqCHLBdUTBwMcMakHQgFFn3MHBiHPBqibfbQfgUyUw');   
    Vue.prototype.$isMessagingEnabled = true
  }catch(err){
    console.warn('error with firebase messaging ' + JSON.stringify(err))
  }
}




import VS2 from 'vue-script2'

Vue.use(VS2)

import * as VueGoogleMaps from 'vue2-google-maps'
 
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCsjfdV7bEDGipipk6ILx7BN2vJcL7g-fQ',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  installComponents: true,
})


Vue.use(VueChartkick, {adapter: Highcharts})

import * as d3 from 'd3';

import Vuetify from 'vuetify'
//import colors from 'vuetify/es5/util/colors'

/* 
Vue.use(Vuetify, {
  theme: {
    primary: colors.purple.base,
    secondary: colors.grey.darken1,
    accent: colors.shades.purple,
    error: colors.red.accent3
  }
})
*/

Vue.use(Vuetify, {
  theme: 
  {
    primary: "#512DA8",
    secondary: "#673AB7",
    accent: "#FFEB3B",
    error: "#f44336",
    warning: "#EF6C00",
    info: "#2196f3",
    success: "#4caf50"
  }  
})


import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCoffee)
library.add(faCreditCard)
Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false
const AlertCmp = () => import('./views/Alert.vue')



Vue.component('app-alert', AlertCmp)
Vue.component('ic-firebase-uploader', IcFirebaseUploader)

new Vue({
  router,
  store,
  components: {
    'ic-firebase-uploader': IcFirebaseUploader
  },
  created () {
    /*
    const config = {
      apiKey: "AIzaSyCaY0N06B9PiBcr0ZK-ZfhAtNltZTgB11g",
      authDomain: "zzques-2e9f8.firebaseapp.com",
      databaseURL: "https://zzques-2e9f8.firebaseio.com",
      projectId: "zzques-2e9f8",
      storageBucket: "zzques-2e9f8.appspot.com",
      messagingSenderId: "951007987182"
    }
  try{
      if (!firebase.apps.length) {
          firebase.initializeApp(config);
      }  
  }catch(err){
      console.log('warn...' + err.message)
  }
*/
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        var member = this.$store.getters.member
        if(member===undefined || member ===null){
          this.$store.dispatch('autoSignIn', user).then(
          )
        }

      }
    })
    firebase.firestore().settings({timestampsInSnapshots: true})
    this.$store.commit('setMyColors')
    var httpequivs = [{equiv: 'Cache-Control',content:'no-cache, no-store, must-revalidate'},
    {equiv: 'Pragma', content:'no-cached'},
    {equiv: 'Expires', content: '0'}]

    httpequivs.forEach(h =>{
      //console.log('httpequivs h', h)
       var meta =  document.createElement('meta')
       meta.content = h.content
       meta.httpEquiv = h.equiv
       document.getElementsByTagName('head')[0].appendChild(meta)
    })
  },  
  render: h => h(App)
}).$mount('#app')
